
// Namespacing

window.Deckperfo = window.Deckperfo  || {};


// FooterShareBtns Module

(function ($) {

    "use strict";

    var self;
    var shareBtns;

    // ------------------------------------
    // CONSTRUCTOR
    // ------------------------------------

    function FooterShareBtns() {

        self = this;
        shareBtns = '.shares a';

    }

    // ------------------------------------
    // INIT
    // ------------------------------------

    FooterShareBtns.prototype.init = function () {

        $( shareBtns ).click(function (event) {
            event.preventDefault();
            window.open($(this).attr("href"), "popupWindow", "width=600,height=600,scrollbars=yes");
        });

    };

    this.FooterShareBtns = new FooterShareBtns();

}.bind(Deckperfo, jQuery)());
